import React from 'react'
import { useRouteMatch } from 'react-router-dom'
import { PageHeader } from 'components/page-header'
import Button from '@material-ui/core/Button'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import AddOutlinedIcon from '@material-ui/icons/AddOutlined'
import NewSponsorshipModal from './new-sponsorship-modal'
import { useQuery } from '@apollo/client'
import Error from 'components/error'
import { GetCoachFacilitiesAndEndorsements } from './queries'
import LinearProgress from '@material-ui/core/LinearProgress'
import SponsorshipsListView from './sponsorships-list-view'

const Sponsorships = () => {
  const { path } = useRouteMatch()

  const crumbs = [
    {
      label: 'Account',
      to: path
        .split('/')
        .slice(0, 2)
        .join('/'),
    },
  ]

  const { data, loading, error, refetch } = useQuery(
    GetCoachFacilitiesAndEndorsements,
  )

  if (error) return <Error error={error} />

  const headerAction = (
    <NewSponsorshipModal
      trigger={
        <Button
          startIcon={<AddOutlinedIcon />}
          variant="contained"
          color="primary"
        >
          New Sponsorship
        </Button>
      }
      onAdd={() => {
        refetch()
      }}
      facilities={data?.currentUser?.attributes?.facilities}
    />
  )

  return (
    <>
      <PageHeader
        title="PGA Coach Sponsorships"
        crumbs={crumbs}
        actions={headerAction}
      />
      <Box my={[3, 4]} px={[2, 5]}>
        {data?.coachEndorsements?.length > 0 && (
          <>
            <Typography variant="h6" gutterBottom>
              PGA Coach Sponsorship
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Review the PGA Coach access sponsorships for individuals who are
              non-PGA Members but work at your facility. Please ensure
              compliance with the PGA of America Code of Ethics during your
              review.
            </Typography>
          </>
        )}
        <Box my={2}>
          {loading ? (
            <LinearProgress />
          ) : (
            <SponsorshipsListView
              endorsements={data?.coachEndorsements}
              facilities={data?.currentUser?.attributes?.facilities}
              refetch={refetch}
            />
          )}
        </Box>
      </Box>
    </>
  )
}

export default Sponsorships
